// extracted by mini-css-extract-plugin
module.exports = {"link":"index-link__SoZcn"};